/**
 * Format a date-only ISO string (``YYYY-MM-DD``) or ISO datetime for display.
 *
 * Date-only strings parse as UTC midnight, so we must also *render* in UTC or
 * the calendar day shifts back one in timezones west of UTC.
 */
export function formatDay(iso: string | null | undefined): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  })
}
